import { NavItem } from 'components/Generic/Header/MegaNavigation/MegaNavigation.types';

const hasChildren = (n: NavItem | undefined): boolean =>
  !!n?.fields?.items && n.fields.items.length > 0;

export function flattenSingleLinkSubcategories(list: NavItem[] | undefined): NavItem[] {
  if (!Array.isArray(list) || !list.length) return [];
  return list.map((node) => flattenNode(node));
}

function flattenNode(node: NavItem): NavItem {
  if (!hasChildren(node)) return node; // leaf already

  // Recursively process children first so we work with flattened descendants
  const processedChildren = node.fields.items.map((c) => flattenNode(c));

  // Replace node if it now effectively has a single child that is a leaf
  if (processedChildren.length === 1 && !hasChildren(processedChildren[0])) {
    return processedChildren[0];
  }

  // Otherwise keep node with processed children
  return {
    ...node,
    fields: {
      ...node.fields,
      items: processedChildren,
    },
  };
}
